import { SESSION_STORAGE_KEY_PREFIX } from '../constants/sessionStorageKeyPrefix';

/** Create session storage key prefix for personal menu */
export const createSessionStorageKey = (parts: (string | number | undefined)[]) =>
  [SESSION_STORAGE_KEY_PREFIX, ...parts.filter((value) => value !== undefined)].join('-');
